/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Laps_EffortsInputs */

const en_ui_laps_efforts = /** @type {(inputs: Ui_Laps_EffortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Efforts`)
};

const de_ui_laps_efforts = /** @type {(inputs: Ui_Laps_EffortsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belastungen`)
};

/**
* | output |
* | --- |
* | "Efforts" |
*
* @param {Ui_Laps_EffortsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_laps_efforts = /** @type {((inputs?: Ui_Laps_EffortsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Laps_EffortsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_laps_efforts(inputs)
	return de_ui_laps_efforts(inputs)
});